const store = {
  verification: {
    pendingEmailVerification: false
  },
  userDetails: {
    email: "",
    username: "",
    givenName: "",
    familyName: "",
    middleName: "",
    phoneNumber: "",
    altPhoneNumber: "",
    profilePhoto: null,
    photoVersion: 0,
    address: {
      city: "",
      line1: "",
      "postal-code": "",
      province: "",
      "street-name": "",
      "street-number": ""
    }
  },
  accountDetails: {
    accountStatus: "",
    accountType: "",
    accountPlan: "",
    accountSubdomain: "",
    expirationDate: "",
    timezone: "",
    clientIsRetired: false,
    agreedToRemarketingTerms: null,
    localeLanguage: "en-CA",
    licenseType: ""
  },
  notificationPreferences: {},
  apiBasePath: "/clients",
  token: "",
  xData: {
    id: "",
    ref: ""
  },
  email: "",
  expiration: "",
  lastCacheCheck: null,
  locale: "",
  selectedApplicationId: "",
  brokerageDetails: {},
  newAccountCreatedEmbeddedLink: false,
  public: {
    agentAccountDetails: {}
  },
  agents: {},
  brokerageId: {},
  verificationEmailSent: false,
  lenderData: {
    agent: {},
    appId: 0,
    client: "",
    documents: [],
    documentsCount: 0,
    subdomain: ""
  }
};
export default store;